interface LabelProps {
  htmlFor: string;
  label: string;
  required?: boolean;
}

export const Label = ({ htmlFor, label, required }: LabelProps) => (
  <label htmlFor={htmlFor} className="font-sans text-sm font-semibold">
    {label}
    {required && (
      <span
        aria-hidden="true"
        className="whitespace-nowrap text-accent_three-700"
      >
        {" "}
        *
      </span>
    )}
  </label>
);
